<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3rmpzb/tc-custom/9781609453213.jpg?1700269582924" alt="This image is the cover for the book Lesser Evils"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lesser Evils
      </h1>
      <p class="bookDescription body article font2">
        <b>“Transposes the corrupt world of James Ellroy’s <i>L.A. Confidential</i> to the Cape Cod of 1957 . . . Ratchets up the suspense to an almost unbearable level” (<i>Publishers Weekly</i>, starred review).</b><br/><br/>When the first young boy goes missing in a quiet Cape Cod town, Bill Warren, who took the job of police chief after returning from World War II, is pulled into a morass that promises no happy ending. As his pursuit uncovers the unimaginable, he is led into a world of criminal conspiracy, a secretive pharmaceutical firm, and an odd local clergyman who may be either a miracle worker or a madman. And while caring for his disabled son, he must fight to maintain control of an investigation in which more and more people—from the state police to the district attorney to a tenacious Boston reporter—are taking a serious interest.<br/><br/>As facts become murkier and the threat rises, Warren struggles to survive in a world where the police can be just as corrupt as the criminals they chase, and where a murder inquiry will ultimately lead to his front door.<br/><br/>“A deftly plotted and perfectly realized crime novel that features one of the most interesting, complex and likable protagonists of recent times.” —Stav Sherez, author of <i>Eleven Days</i><br/><br/>“[A] highly impressive debut.” —<i>Publishers Weekly</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Flanagan
      </h2>
      
      <p class="authorDescription body article">Joe Flanagan was born in Hyannis, Massachusetts. He has worked as a freelance writer, a speechwriter, and magazine editor. His fiction has appeared in the anthology Glimmer Train. He lives in Alexandria, Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c342e4a